module.exports = __webpack_public_path__ + "static/media/spinola-logo.aa40ac5a.png";